import React from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { convertISO_8601 } from '../../util';
import axios from 'axios';
import "./styles.css";
class PipelineIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: null
    };
  }
  handleMouseIn() {
    this.setState({
      hover: true
    });
  }
  handleMouseOut() {
    this.setState({
      hover: false
    });
  }
  openInNewTab(url) {
    window.location.href = url;
  }
  render() {
    const tooltipStyle = {
      display: this.state.hover ? 'block' : 'none',
      position: "absolute",
      top: "-24px",
      left: "38px",
      fontSize: "0.75rem",
      padding: "0.25rem"
    };
    return /*#__PURE__*/React.createElement("span", {
      tabIndex: "0",
      onMouseOver: this.handleMouseIn.bind(this),
      onMouseOut: this.handleMouseOut.bind(this)
    }, this.props.latestDeploy.status === "success" && /*#__PURE__*/React.createElement("span", {
      role: "button",
      "aria-describedby": "pipeline-tooltip-text",
      onClick: () => {
        this.openInNewTab(this.props.latestDeploy.web_url);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "pipeline-icon bi-check-circle pipeline-succeeded"
    })), this.props.latestDeploy.status === "pending" && /*#__PURE__*/React.createElement("span", {
      role: "button",
      "aria-describedby": "pipeline-tooltip-text",
      onClick: () => {
        this.openInNewTab(this.props.latestDeploy.web_url);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "pipeline-icon bi-p-circle pipeline-pending"
    })), this.props.latestDeploy.status === "failure" && /*#__PURE__*/React.createElement("span", {
      role: "button",
      "aria-describedby": "pipeline-tooltip-text",
      onClick: () => {
        this.openInNewTab(this.props.latestDeploy.web_url);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "pipeline-icon bi-x-circle pipeline-failed"
    })), /*#__PURE__*/React.createElement("span", {
      style: tooltipStyle
    }, /*#__PURE__*/React.createElement("span", {
      id: "pipeline-tooltip-text",
      className: "pipeline-tooltip-inner"
    }, "Link to Pipeline")));
  }
}
export default class PipelineButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pipelineInfo: null
    };
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    this.fetchPipeline(this.props.repoId);
  }
  getLatestDeployment() {
    if (this.state.pipelineInfo === null) {
      return null;
    }
    const dateTime = convertISO_8601(this.state.pipelineInfo.data[0].created_at);
    return {
      date: dateTime.dateComponent,
      time: dateTime.timeComponent,
      status: this.state.pipelineInfo.data[0].status,
      branch: this.state.pipelineInfo.data[0].ref,
      web_url: this.state.pipelineInfo.data[0].web_url
    };
  }
  // curl --header "PRIVATE-TOKEN: glpat-yjarGdjtew73eYSLFTFK" "https://gitlab.com/api/v4/projects/31253932/pipelines"
  async fetchPipeline(repoId) {
    const response = await axios('https://gitlab.com/api/v4/projects/' + repoId + "/pipelines", {
      headers: {
        "Private-Token": 'glpat-yjarGdjtew73eYSLFTFK'
      } // TODO: move to .env file 
    }).then(r => {
      if (r.message) {
        this.setState({
          pipelineInfo: null
        }, () => {
          console.log("pipeline fetch error", r.message);
        });
      } else {
        this.setState({
          pipelineInfo: r
        }, () => {
          console.log("pipeline fetch success", this.state.pipelineInfo);
        });
      }
    }).catch(e => {
      console.error(e);
    });
    return response;
  }
  closeModal() {
    this.setState({
      pipelineModalOpen: false
    });
  }
  render() {
    const latestDeploy = this.getLatestDeployment();
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.pipelineInfo && /*#__PURE__*/React.createElement("div", {
      className: "pipeline-group"
    }, /*#__PURE__*/React.createElement("span", {
      className: "pipeline-text"
    }, "Pipeline Status:"), /*#__PURE__*/React.createElement(PipelineIcon, {
      latestDeploy: latestDeploy
    }), /*#__PURE__*/React.createElement(Button, {
      className: "pipeline-button",
      variant: "primary",
      onClick: () => {
        this.fetchPipeline(this.props.repoId);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-arrow-clockwise"
    }))));
  }
}